<template>
  <div class="subcats">
    <ui-button
      v-for="subcat in subcats"
      :key="'route_' + subcat.slug"
      class="subcats__btn btn--reset"
      markup="router-link"
      :to="subcat.to"
      text
    >
      {{ subcat.title }}
    </ui-button>
  </div>
</template>
<script>
import UiButton from "@/components/ui/UiButton.vue";
export default {
  components: { UiButton },

  name: "SubCats",
  props: {
    category: { type: Object }
  },
  data() {
    return {
      subcats: []
    };
  },
  mounted() {
    this.setSubcats();
  },

  methods: {
    setSubcats() {
      this.subcats.push({
        title: "Tous",
        slug: "all",
        to: {
          name: "category",
          params: { slug: this.$route.params.slug }
        }
      });
      this.category.sub_categories.forEach(cat => {
        this.subcats.push({
          title: cat.name,
          slug: cat.slug,
          to: {
            name: "subcategory",
            params: { slug: this.$route.params.slug, subcat: cat.slug }
          }
        });
      });
    }
  }
};
</script>
<style lang="scss">
.subcats {
  display: flex;
  justify-content: center;
  align-items: center;
  &::before,
  &::after {
    content: $pseudo-content;
    display: inline-block;
    width: 1em;
    height: 1px;
    margin: 0 0.3em;
    background: darken($secondary, 10);
  }
  &__btn {
    margin: 0 5px;
    text-transform: uppercase;
    @include font-title();
    &.router-link-exact-active {
      color: darken($secondary, 10);
      border-bottom: 1px $secondary;
    }
  }
}
</style>
